(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  var rechargeBuyNowButtonSelector = 'button[id="subscription-buy-now"]';
  var shopifyBuyNowButtonSelector = '[data-shopify="payment-button"]';
  
  var toggleBuyNowButton = function() {
      var purchaseTypeElement = document.querySelector('[name="purchase_type"]:checked');
      var selectedPurchaseType = purchaseTypeElement ? purchaseTypeElement.value : null;

      if(selectedPurchaseType == 'onetime') {
          document.querySelector(shopifyBuyNowButtonSelector).style.display = 'block';
          document.querySelector(rechargeBuyNowButtonSelector).style.display = 'none';

      } else {
          document.querySelector(shopifyBuyNowButtonSelector).style.display = 'none';
          document.querySelector(rechargeBuyNowButtonSelector).style.display = 'block';
      }
  }

  toggleBuyNowButton();
  document.querySelector('[id="rc_radio_options"]').addEventListener('click', toggleBuyNowButton);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-product-page"]) return;
  try {
    
	if(location.pathname.includes('recommended-product')) {
		location.search.substr(1).split('&').forEach(function(param) {
			var classElement = '.' + param.split('=')[1];
			var elem = document.querySelector(classElement);
			if(elem) elem.style.display = "inline-block";
		});
	}

  } catch(e) { console.error(e); }
})();
})();
